'use client';

import { usePathname } from 'next/navigation';
import Header from './Header';

export default function ConditionalHeader() {
  const pathname = usePathname();

  // Do not show the header in the terms and conditions page
  if (pathname?.includes('terms-and-conditions')) {
    return null;
  }

  return <Header />;
}
